import { ref, computed } from 'vue';
export default {
  props: {
    columnsType: {
      type: Array,
      default: () => {
        return ['year', 'month', 'day'];
      }
    }
  },
  setup(props, context) {
    const show = ref(false);
    const showView = () => {
      show.value = true;
    };
    const onCancelClick = () => {
      show.value = false;
    };
    const minDate = computed(() => {
      const today = new Date();
      return new Date(today.getFullYear() - 100, 1, 1);
    });
    const maxDate = computed(() => {
      const today = new Date();
      return new Date(today.getFullYear() + 100, 1, 1);
    });
    const currentDate = ref([]);
    const today = new Date();
    let year = today.getFullYear().toString();
    let month = (today.getMonth() + 1).toString();
    if (month.length == 1) {
      month = `0${month}`;
    }
    let day = today.getDate().toString();
    if (day.length == 1) {
      day = `0${day}`;
    }
    if (props.columnsType.toString() == ['year', 'month', 'day'].toString()) {
      currentDate.value = [year, month, day];
    } else if (props.columnsType.toString() == ['year', 'month'].toString()) {
      currentDate.value = [year, month];
    } else if (props.columnsType.toString() == ['year'].toString()) {
      currentDate.value = [year];
    }
    const onConfirmClick = ({
      selectedValues
    }) => {
      currentDate.value = selectedValues;
      show.value = false;
      context.emit('onSelectedChange', currentDate.value.join("-"));
    };
    return {
      show,
      showView,
      minDate,
      maxDate,
      currentDate,
      onConfirmClick,
      onCancelClick
    };
  }
};